<!--
 * @Description: 
 * @Date: 2020-11-10 16:47:38
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-04-27 18:38:45
-->
<template>
  <div class="custom-pie">
    <div class="custom-pie-item">
      <svg
        class="svg"
        :width="svgWidth"
        :height="svgHeight"
        :viewport="`0 0 ${svgWidth} ${svgHeight}`"
      >
        <g
          class="svg-content"
          :style="{
            transform: `translate(25px, ${svgHeight - height - 20}px)`
          }"
        >
          <rect
            :x="-20"
            :y="-5"
            :width="width + 35"
            :height="height + 15"
            fill="#EBEEF8"
          />
          <g
            v-for="(aItem, aIndex) in pathArrs"
            :key="aIndex"
            :style="aItem.style"
            @mouseenter="$set(pathHover, aIndex, true)"
            @mouseleave="$set(pathHover, aIndex, false)"
          >
            <path
              class="custom-pie-item-block"
              v-for="(v, k) in aItem.surface.surfaces"
              :key="k"
              :d="v"
              :fill="
                colorArr[aIndex % 6](
                  (k == 'top' ? 1 : k == 'front' ? 0.35 : 0.5) -
                    (pathHover[aIndex] ? 0.1 : 0)
                )
              "
              stroke="red"
              stroke-width="0"
              :data-v="v"
              :data-k="k"
            />
            <g class="text">
              <ellipse
                :cx="aItem.textPoint[0]"
                :cy="aItem.textPoint[1]"
                rx="5"
                ry="2"
                fill="rgba(235, 238, 248, 0.4)"
              />
              <line
                :x1="aItem.textPoint[0]"
                :y1="aItem.textPoint[1]"
                :x2="aItem.textPoint[0]"
                :y2="aItem.textPoint[1] - aItem.index * 30 - height / 2 - 20"
                stroke-width="1"
                stroke="#9F9F9F"
              />
              <line
                :x1="aItem.textPoint[0]"
                :y1="aItem.textPoint[1] - aItem.index * 30 - height / 2 - 20"
                :x2="aItem.textPoint[0] + 30"
                :y2="aItem.textPoint[1] - aItem.index * 30 - height / 2 - 20"
                stroke-width="1"
                stroke="#9F9F9F"
              />
              <text
                style="font-size:12px;"
                :x="aItem.textPoint[0] + 35"
                :y="aItem.textPoint[1] - aItem.index * 30 - height / 2 - 15"
                fill="#323333"
              >
                {{ aItem.info.name }}：{{ aItem.info.b }}
              </text>
            </g>
          </g>
        </g>
      </svg>
    </div>
    <Table :table="table" :normalTable="table && table.isNormal"></Table>
  </div>
</template>

<script>
import { colorArr } from '../color/config.js';
import { get3dSurfacePath, dealSurfaces } from './common/tools.js';
import Table from '../Table';
export default {
  props: {
    series0data: {
      type: Array,
      default: () => []
    },
    finalDataCount: {
      type: Number,
      default: 0
    },
    unit: {
      type: String,
      default: '单'
    },
    table: {
      type: Object,
      default() {
        return null;
      }
    }
  },
  data() {
    return {
      colorArr,
      pathArrs: [],
      pathHover: [],
      width: 300,
      height: 60,
      dis: 13
    };
  },
  components: { Table },
  computed: {
    svgWidth() {
      return 430;
    },
    svgHeight() {
      const { dealSeries0data } = this;
      return Math.max(dealSeries0data.length * 50, 200) + 20;
    },
    dealSeries0data() {
      return this.series0data.filter(i => i.value > 0);
    }
  },
  methods: {},
  created() {
    const { dis, width, height, finalDataCount } = this;
    let startX = 0;
    this.pathArrs = this.dealSeries0data.reduce((pre, cur, index, arr) => {
      const _width =
        (cur.value / finalDataCount) * (width - (arr.length - 1) * dis);
      pre.push({
        surface: dealSurfaces(
          get3dSurfacePath({
            leftTopPoint: [startX, 0],
            rightTopPoint: [startX + _width, 0],
            rightBottomPoint: [startX + _width, height],
            leftBottomPoint: [startX, height],
            height: 10,
            xMoveDis: -8
          })
        ),
        index: arr.length - 1 - index,
        textPoint: [startX + _width / 2 - 8, height / 2 - 10],
        info: cur
      });
      startX += _width + dis;
      return pre;
    }, []);
  }
};
</script>
<style lang="scss" scoped>
.custom-pie {
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-wrap: wrap;
  &-item {
    .p {
      transform: translateY(-10px);
      &-1 {
        font-size: 14px;
        color: #434343;
        line-height: 1;
      }
      &-2 {
        font-size: 24px;
        color: #434343;
        line-height: 1;
        margin-top: 22px;
      }
    }
  }
}
.svg {
  path {
    transition: all 0.3s;
  }
  &-content {
    .custom-pie-item-block {
      cursor: pointer;
    }
    .shodow {
      transform-origin: 120px 55px;
      transform: translateX(-10px) translateY(90px);
    }
  }
}
</style>
